import { Injectable } from "@angular/core";
import { Socket, SocketIoConfig } from "ngx-socket-io";

export class Utils {

   /**
    * Funcion recursiva que transforma todos los datos en string que podrían
    * ser number. Es capaz de recibir todo tipo de variables
    * (array, objetos, ...)
    * @param data
    */

   transformStringToNumber( data ) {
      if ( data === null ) {
         return data;
      }

      switch ( typeof data ) {
         case "object":
            if ( Array.isArray(data) ) {
               data.map(item => item = this.transformStringToNumber(item));
            } else {
               Object.keys(data).map((key, index) => {
                  data[key] = this.transformStringToNumber(data[key]);
               });
            }

            return data;
         break;
         case "string":
            if ( data !== '' ) {
               data = !Number.isNaN(Number(data)) ? Number(data) : data;

               if (/((\d\d\d\d)-(\d\d)-(\d\d)) ((\d\d):(\d\d):(\d\d))*/.test(data)){
                  data = new Date(data);
               }
            }
            return data;
         break;
         default:
            return data;
         break;
      }
   }

   /**
    * Los adjuntos se reciben siempre con la misma estructura, esta estructura
    * no es directamente compatible con el front-end, por ello utilizamos
    * esta funciona para transformar la estructura a datos facilmente
    * utilizables
    * @param data
    */

   parseAttachments( data ) {
      let array_tipos;
      let array_adjuntos;
      let i;
      let tipo;
      let adjuntos = [];

      // Genero todos los adjuntos
      if ( data.tipoadjunto !== null && data.tipoadjunto !== undefined && data.tipoadjunto !== 0 ) {
         array_tipos = data.tipoadjunto.split(',');
         array_adjuntos = data.adjunto.split(',');

         for ( i = 0; i < array_tipos.length; i++ ) {
            switch (array_tipos[i]) {
               case "0":
                  tipo = 'imagen';
                  break;
               case "1":
                  tipo = 'video';
                  break;
               case "3":
                  tipo = 'documento';
                  break;
            }

            adjuntos.push({tipo: tipo, adjunto: array_adjuntos[i].replace("/var/www/html/ideacomonjas_ardal/", "")});
         }

         data.adjuntos = adjuntos;
      }

      delete data.tipoadjunto;
      delete data.adjunto;

      return data;
   }

   /**
    * Remapea el valor de un rango a otro
    * @param value
    * @param low1
    * @param high1
    * @param low2
    * @param high2
    */
   remap(value, low1, high1, low2, high2) {
      return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
   }


   generateToken() {
      // Math.random should be unique because of its seeding algorithm.
      // Convert it to base 36 (numbers + letters), and grab the first 9 characters
      // after the decimal.
      return 't_' + Math.random().toString(36).substr(2, 10);
   };
}

@Injectable({
   providedIn: 'root'
})
export class SocketService {
   private static instance: SocketService;
   private _socket: Socket;
   private _connected: boolean = false;

   config : SocketIoConfig = {
      url: localStorage.getItem('apiJsSimple'),
      options: {
         autoConnect: false
      }
   }
   constructor() {}

   get connected(): boolean {
      return this._connected;
   }

   get socket(): Socket {
      return this._socket;
   }

   public static getIntance(): SocketService {


      if ( !SocketService.instance ) {
         SocketService.instance = new SocketService();
      }
      return SocketService.instance;
   }

   disconnect(){
      console.log('ME ESTOY DESCONECTADO');
      this._socket.removeAllListeners();
      this._socket.disconnect();
   }

   connect(){


      console.log(localStorage.getItem("apiJsSimple") )
      if (  localStorage.getItem("apiJsSimple") !== undefined &&
      localStorage.getItem("apiJsSimple") !== null  ) {
         this.config.url = localStorage.getItem('apiJsSimple');
         this._socket = new Socket(this.config);
         this._socket.connect();
         this._socket.on('connect', () => {
            this._connected = true;
         });
         this._socket.on('disconnect', () => {
            this._connected = false;
         });
      }

   }

}


// @Injectable()
// export class WebSocket extends Socket {

//    constructor() {
//       alert(9)
//       super({url: localStorage.getItem('apiJsSimple') , options: {
//          autoConnect: false
//       }});
//    }



// }

@Injectable()
export class SocketSoaTs extends Socket {
   constructor() {
      super({ url: 'https://soats.hometech.red/', options: { } });
   }
}
